import React from 'react'
import { portImg1 } from '../../img/portfolio'
import { portafolios } from './Data'


import {
    PortfolioContainer,
    PortfoliosTextWrapper,
    PortfolioWrapper,
    PortfolioRow,

    PortfoliosCard,
    PortfoliosH1,
    PortfoliosH2,
    PortfoliosIcon,
    PortfoliosP
} from './PortfolioElements'

import { Carousel } from 'react-carousel-minimal';


const PortfolioSection = () => {
    const captionStyle = {
        fontSize: '2em',
        fontWeight: 'bold',
        display: 'none',
    }
    const slideNumberStyle = {
        fontSize: '20px',
        fontWeight: 'bold',
    }
    return (
        <>
            <PortfolioContainer id='portfolio'>
                <PortfoliosTextWrapper>
                    <PortfoliosH1>Portfolio</PortfoliosH1>
                </PortfoliosTextWrapper>
                <PortfolioWrapper>
                    <Carousel
                        data={portafolios}
                        time={2000}
                        width="100%"
                        height="65vh"
                        captionStyle={captionStyle}
                        radius="20px"
                        slideNumber={true}
                        slideNumberStyle={slideNumberStyle}
                        captionPosition="bottom"
                        automatic={true}
                        dots={true}
                        pauseIconColor="white"
                        pauseIconSize="40px"
                        slideBackgroundColor="darkgrey"
                        slideImageFit="cover"
                        thumbnails={true}
                        thumbnailWidth="100px"
                        style={{
                            textAlign: "center",
                            maxWidth: "100%",
                            maxHeight: "700px",
                            margin: "50px auto",
                        }}
                    />


                    <PortfolioRow>



                        {/* {portafolios.map((item,index)=>
                                <PortfoliosCard key={item.id} white={true} image={item.Icon}>
                                    <h1>{item.title}</h1>
                                 </PortfoliosCard>

                        )} */}
                    </PortfolioRow>
                </PortfolioWrapper>
            </PortfolioContainer>
        </>
    )
}

export default PortfolioSection
